import {
  Controller,
  type Control,
  type FieldErrors,
  type UseFormRegister,
  type UseFormSetValue,
  type UseFormWatch,
} from 'react-hook-form';
import type { AddResidentData } from '../AddResidentForm';
import { Dropdown, Input, Toggle } from '@/shared';

// ---------------------------- Step 3 ----------------------------
const paymentFrequencyOptions = [
  { label: 'Monthly', value: 'MONTHLY' },
  { label: '3 Months', value: 'QUARTERLY' },
  { label: '6 Months', value: 'HALFYEARLY' },
  { label: 'Yearly', value: 'YEARLY' },
];

interface PaymentDetailsProps {
  control: Control<AddResidentData>;
  register: UseFormRegister<AddResidentData>;
  errors: FieldErrors<AddResidentData>;
  setValue: UseFormSetValue<AddResidentData>;
  watch: UseFormWatch<AddResidentData>;
}

export const ResidentPaymentDetailsForm: React.FC<PaymentDetailsProps> = ({
  control,
  register,
  errors,
  setValue,
  watch,
}) => {
  const customChargesEnabled = watch('customChargesEnabled');

  return (
    <>
      <Input
        label="Monthly Program Fee"
        type="number"
        {...register('monthlyFee')}
        error={errors.monthlyFee?.message}
      />
      <Controller
        name="paymentFrequency"
        control={control}
        render={({ field }) => (
          <Dropdown
            label="Payment Frequency"
            options={paymentFrequencyOptions}
            value={field.value}
            buttonClassName="!w-full"
            onChange={field.onChange}
          />
        )}
      />
      <Input
        label="Security Deposit"
        type="number"
        {...register('securityDeposit')}
        error={errors.securityDeposit?.message}
      />
      <div className="flex items-center justify-between">
        <span className="text-text-primary">Custom Charges</span>
        <Toggle
          value={!!customChargesEnabled}
          onChange={() =>
            setValue('customChargesEnabled', !customChargesEnabled)
          }
        />
      </div>
    </>
  );
};
